import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ChangesTrackerService {
  private changedEntityId: string | null = null;
  private changedEntityType: string | null = null;

  trackChange(id: string, type: string): void {
    this.changedEntityId = id;
    this.changedEntityType = type;
  }

  getChangedEntity(type: string): { id: string; type: string } | null {
    if (!this.changedEntityId || !this.changedEntityType) {
      return null;
    }

    if (this.changedEntityType !== type) {
      return null;
    }

    const result = {
      id: this.changedEntityId,
      type: this.changedEntityType
    };

    return result;
  }

  getChangedEntityType(): string | null {
    return this.changedEntityType;
  }

  navigateToChangedEntity(document: Document): void {
    if (!this.changedEntityId || !this.changedEntityType) {
      return;
    }
    var ctx = this;
    setTimeout(() => {
      const anchorId = `${ctx.changedEntityType}_${ctx.changedEntityId}`;
      const element = document.getElementById(anchorId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      ctx.clearTracking();
    }, 100);
  }

  clearTracking(): void {
    this.changedEntityId = null;
    this.changedEntityType = null;
  }
}
